import { render, staticRenderFns } from "./CustomerOptInFilter.vue?vue&type=template&id=8755bc4c"
import script from "./CustomerOptInFilter.vue?vue&type=script&lang=js"
export * from "./CustomerOptInFilter.vue?vue&type=script&lang=js"
import style0 from "./CustomerOptInFilter.vue?vue&type=style&index=0&id=8755bc4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports